export const footerFervente = [
    {
        name: { tr: 'Biz Kimiz', en: 'About Us' },
        slug: {
            en: '/about-us',
            tr: '/biz-kimiz',
        },
    },

    {
        name: { tr: 'İletişim', en: 'Contact Us' },
        slug: {
            en: '/contact',
            tr: '/iletisim',
        },
    },
    {
        name: { tr: 'Sıkça Sorulan Sorular', en: 'FAQ' },
        slug: {
            en: '/faq',
            tr: '/sikca-sorulan-sorular',
        },
    },
    /* {
        name: { tr: 'Kolay İade', en: 'Easy Return' },
        slug: { en: '/easy-return', tr: '/kolay-iade' },
    }, */
];

export const footerFollow = [
    {
        name: { tr: 'Facebook', en: 'Facebook' },
        slug: {
            en: 'https://www.facebook.com/ferventeshop',
            tr: 'https://www.facebook.com/ferventeshop',
        },
    },
    {
        name: { tr: 'Instagram', en: 'Instagram' },
        slug: {
            en: 'https://www.instagram.com/ferventeshop',
            tr: 'https://www.instagram.com/ferventeshop',
        },
    },
];

export const footerHelp = [
    {
        name: 'Terms and Conditions',
        slug: '/terms-conditions',
    },
    {
        name: 'Privacy Policy',
        slug: '/privacy-policy',
    },
    {
        name: 'Catalog',
        slug:
            'https://conversionline.io/pdf-reader?pdfURL=https://cloud.keikei.com/cdn/fervente/catalog/fervente-catalog.pdf',
        type: 'catalog',
    },
];
